import React from 'react';
import './MicrosoftLoginButton.scss';

interface MicrosoftLoginButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}

const MicrosoftLoginButton: React.FC<MicrosoftLoginButtonProps> = ({
  onClick,
  disabled = false,
  loading = false,
}) => {
  return (
    <button
      type="button"
      className={`microsoft-login-button ${disabled || loading ? 'disabled' : ''}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      <div className="microsoft-login-content">
        {loading ? (
          <div className="loading-spinner" />
        ) : (
          <svg className="microsoft-icon" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="9" height="9" fill="#f25022" />
            <rect x="12" y="1" width="9" height="9" fill="#00a4ef" />
            <rect x="1" y="12" width="9" height="9" fill="#ffb900" />
            <rect x="12" y="12" width="9" height="9" fill="#7fba00" />
          </svg>
        )}
        <span className="microsoft-text">
          {loading ? 'Signing in...' : 'Sign in with Microsoft'}
        </span>
      </div>
    </button>
  );
};

export default MicrosoftLoginButton;